import { Role } from 'src/types';

// Reusable role groups — the single source of truth for every route's
// allowList. Both `RootRouter` (route guards) and `Sidebar` (menu config)
// must read from `routeAccess` so the guard and the menu can never drift
// (a menu item showing a route the guard denies, or vice-versa).
const ANALYST_UP: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst];
const STANDARD_ADMINS: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst, Role.ClientAdmin];
const STANDARD_ADMINS_PLUS_CUSTOMER_OPS: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.ClientAdmin,
  Role.CustomerOperations,
];
// All product roles excluding EmployerAdmin/Viewer (which are not used by
// any EmployerHub route guard today). Order is irrelevant — guards use
// `allowList.includes(userRole)`.
const ALL_PRODUCT_ROLES: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.ClientAdmin,
  Role.Manager,
  Role.CustomerOperations,
];

// Keys correspond to `RoutePath` members. Lookups are membership-based, so
// array order is not significant for guard/menu behaviour.
export const routeAccess = {
  // Top-level guarded branches (consumed by RootRouter)
  configurationRoot: ALL_PRODUCT_ROLES,
  dataManagementRoot: ALL_PRODUCT_ROLES,
  reportingRoot: ALL_PRODUCT_ROLES,
  productInfo: ANALYST_UP,

  // Configuration — children
  configurationTemplateDefinitionRoot: ANALYST_UP,
  configurationMemberRequestSettings: ANALYST_UP,
  configurationAdminSyncRoot: STANDARD_ADMINS,
  configurationValidationsRoot: STANDARD_ADMINS_PLUS_CUSTOMER_OPS,
  configurationPayrollsList: ALL_PRODUCT_ROLES,
  configurationPayrollsAddRoot: STANDARD_ADMINS,

  // Data Management — children
  dataManagementDataAmendmentsRoot: STANDARD_ADMINS_PLUS_CUSTOMER_OPS,
  dataManagementPayrollFileChangesDownloadAudit: ALL_PRODUCT_ROLES,

  // Reporting — children
  reportingReportsRoot: STANDARD_ADMINS_PLUS_CUSTOMER_OPS,
  reportingHistoryRoot: STANDARD_ADMINS_PLUS_CUSTOMER_OPS,
  reportingLatePaymentReportRoot: STANDARD_ADMINS_PLUS_CUSTOMER_OPS,
  reportingRequestsList: ALL_PRODUCT_ROLES,
  reportingPayrollSummaryReportRoot: STANDARD_ADMINS_PLUS_CUSTOMER_OPS,
  reportingValidationInsightsRoot: ALL_PRODUCT_ROLES,
};
